import commonGlobals from '@opendoor/shared-fe/build/commonGlobals';
import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

const odRailsEnv = getRailsEnv();
const secrets = commonGlobals[odRailsEnv];

export const DATADOG_RUM_APPLICATION_ID = 'c21bbccd-a46b-432f-8f7f-6cef3754256f';
export const DATADOG_RUM_APPLICATION_CLIENT_TOKEN = 'pubdb1176bc914dc1be554183ad33336361';

// Google API calls use this project for billing and API keys:
// https://console.cloud.google.com/apis/credentials?project=val-tool-3-1495755979574&organizationId=727186813944
export const GOOGLE_MAPS_API_KEY = secrets.googleMaps;
export const WEB_API_URL = secrets.webApiUrl;
export const GOOGLE_CLIENT_ID = secrets.googleClientID;
export const CAKE_URL = secrets.cakeUrl;
export const COOKIE_KEY = window.location.hostname === 'localhost' ? 'XSRF-TOKEN' : 'XSRF-G-TOKEN';

export const CXA_EMAIL_NEW = 'support@opendoor.com';

const formatSMSNumber = (smsNumber: string) => {
  return smsNumber.replace(/[^\d]/g, '');
};

export const CXA_SMS_NUMBER = '(480) 462-5392';
export const CXA_SMS_NUMBER_FORMATTED = formatSMSNumber(CXA_SMS_NUMBER);

const globals = {
  development: {
    offerFeUrl: 'https://localhost:3008',
    receptionFeUrl: 'https://localhost:3010',
  },
  qa: {
    offerFeUrl: 'https://consumer.simplersell.com',
    receptionFeUrl: 'https://consumer.simplersell.com',
  },
  staging: {
    offerFeUrl: 'https://consumer.simplersell.com',
    receptionFeUrl: 'https://consumer.simplersell.com',
  },
  production: {
    offerFeUrl: 'https://consumer.opendoor.com',
    receptionFeUrl: 'https://consumer.opendoor.com',
  },
  test: {
    offerFeUrl: 'https://localhost:3008',
    receptionFeUrl: 'https://localhost:3010',
  },
};

export const BASE_URL = globals[odRailsEnv].receptionFeUrl;

export const addressEntryUrl = `${WEB_API_URL}/address-entry`;
